import React from 'react';
import students from '../../../img/students.png';
import BookButton from '../../Shared/BookButton';
import journey1 from '../../../img/journey-1.png';
import journey2 from '../../../img/journey-2.png';
import journey3 from '../../../img/journey-3.png';
import journey4 from '../../../img/journey-4.png';
import journey5 from '../../../img/journey-5.png';
import journey6 from '../../../img/journey-6.png';

const JourneyWithUs = () => {
    return (
        <div className='py-8 md:py-12 px-4 md:px-12 rounded-md'>
            <h1 className='text-2xl md:text-3xl font-semibold text-center'>Your Journey with <span className='text-blue-500'> Career Hikers </span></h1>
            <div className='grid grid-cols-1 gap-4 md:flex md:flex-row-reverse py-6 mt-6 bg-pink-50'>
                <div className='flex-1'>
                    <img src={students} className='mx-auto mt-6 rounded-md bg-white p-2' alt="" />
                </div>
                <div className='flex-1'>
                    <div className='grid grid-cols-2 gap-8 ml-4'>
                        <div className='bg-white py-2 px-4 flex items-center rounded-md'>
                            <img src={journey1} alt="" className='w-24 p-2 rounded-full bg-pink-100 mr-3' />
                            <p className='text-sm text-left'>Take a free counseling session</p>
                        </div>
                        <div className='bg-white py-2 px-4 flex items-center rounded-md'>
                            <img src={journey2} alt="" className='w-24 p-2 rounded-full bg-pink-100 mr-3' />
                            <p className='text-sm text-left'>Join ABHAY Program get complete Career Guidance</p>
                        </div>
                        <div className='bg-white py-2 px-4 flex items-center rounded-md'>
                            <img src={journey3} alt="" className='w-24 p-2 rounded-full bg-pink-100 mr-3' />
                            <p className='text-sm text-left'>Weekly Live mentorship sessions</p>
                        </div>
                        <div className='bg-white py-2 px-4 flex items-center rounded-md'>
                            <img src={journey4} alt="" className='w-24 p-2 rounded-full bg-pink-100 mr-3' />
                            <p className='text-sm text-left'>Explore Opportunities</p>
                        </div>
                        <div className='bg-white py-2 px-4 flex items-center rounded-md'>
                            <img src={journey5} alt="" className='w-24 p-2 rounded-full bg-pink-100 mr-3' />
                            <p className='text-sm text-left'>Ace Your Goals</p>
                        </div>
                        <div className='bg-white py-2 px-4 flex items-center rounded-md'>
                            <img src={journey6} alt="" className='w-24 p-2 rounded-full bg-pink-100 mr-3' />
                            <p className='text-sm text-left'>Share your experience with us</p>
                        </div>
                    </div>
                    <div className='flex justify-center'>
                        <BookButton name='Start Your Journey Now!' />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default JourneyWithUs;